/* SOLARA Bundle Builder v2.1 runtime
 * Finds every `.solara-bb` instance on the page and initializes each.
 * Each instance reads:
 *   - config from <script type="application/json" data-bb-config>
 *   - products from <script type="application/json" data-bb-products>
 * Product data is rendered from a Shopify collection in Liquid, so price and
 * availability match the store at page load. A pre-submit revalidation against
 * /products/{handle}.js catches anything that sold out mid-session.
 * Free shipping is evaluated on the pre-discount subtotal (decision R1).
 */
(function () {
  'use strict';

  var REDUCED_MOTION = false;
  try {
    REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function init(root) {
    if (!root || root.dataset.bbInit === '1') return;
    root.dataset.bbInit = '1';

    var $  = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // Config + products
    var CFG = {
      currency: 'AUD',
      discountPct: 0.05,
      discountMinItems: 3,
      freeShipMin: 150,
      bundleToken: 'BUNDLEBUILDER',
      bundleSlug: 'moto-camping'
    };
    var cfgEl = root.querySelector('[data-bb-config]');
    if (cfgEl) {
      try {
        var raw = JSON.parse(cfgEl.textContent || '{}');
        if (raw.currency)                 CFG.currency = raw.currency;
        if (raw.discountPct != null)      CFG.discountPct = Number(raw.discountPct);
        if (raw.discountMinItems != null) CFG.discountMinItems = Number(raw.discountMinItems);
        if (raw.freeShipMin != null)      CFG.freeShipMin = Number(raw.freeShipMin);
        if (raw.bundleToken)              CFG.bundleToken = raw.bundleToken;
        if (raw.bundleSlug)               CFG.bundleSlug = raw.bundleSlug;
      } catch (e) { console.warn('SOLARA bundle: bad config JSON', e); }
    }

    var products = [];
    var prodEl = root.querySelector('[data-bb-products]');
    if (prodEl) {
      try { products = JSON.parse(prodEl.textContent || '[]') || []; }
      catch (e) { console.error('SOLARA bundle: bad product JSON', e); return; }
    }

    // Build variant -> {product, variant} lookup map. Bundle is keyed by variant id.
    var variantMap = {};
    var productByHandle = {};
    products.forEach(function (p) {
      productByHandle[p.handle || p.id] = p;
      var vs = p.variants && p.variants.length
        ? p.variants
        : [{ id: p.variant_id, title: '', price: p.price, available: p.available !== false }];
      vs.forEach(function (v) {
        var avail = v.available !== false;
        variantMap[String(v.id)] = { product: p, variant: v, available: avail };
      });
    });
    function variantsOf(p) {
      return p.variants && p.variants.length
        ? p.variants
        : [{ id: p.variant_id, title: '', price: p.price, available: p.available !== false }];
    }
    function productAvailable(p) {
      if (p.available === false) return false;
      return variantsOf(p).some(function (v) { return v.available !== false; });
    }
    function firstAvailableVariant(p) {
      var vs = variantsOf(p);
      var found = vs.find(function (v) { return v.available !== false; });
      return found || vs[0];
    }
    function productPrice(p) {
      return Number(firstAvailableVariant(p).price) || 0;
    }
    function productWeight(p) {
      return Number(firstAvailableVariant(p).weight_g || p.weight_g) || 0;
    }

    // State + persistence (v2: keyed by variant id, not product id)
    var bundle = {};
    var filter = 'all';
    var sortBy = 'essential';
    // Customer's variant choice per product, so re-renders (filter, sort,
    // kits) never reset a multi-variant card back to its first variant.
    var selectedVariant = {};
    var storageKey = 'solara-bundle-v2-' + CFG.bundleSlug;

    try {
      var saved = localStorage.getItem(storageKey);
      if (saved) bundle = JSON.parse(saved) || {};
    } catch (e) { bundle = {}; }

    // Rehydration: drop variants that no longer exist AND variants that have
    // since gone out of stock. A returning customer must never see a bundle
    // containing unbuyable items or a total that will not survive checkout.
    var droppedOnLoad = 0;
    Object.keys(bundle).forEach(function (vid) {
      var entry = variantMap[vid];
      if (!entry) { delete bundle[vid]; return; }
      if (!entry.available) { delete bundle[vid]; droppedOnLoad++; }
    });

    function persist() {
      try { localStorage.setItem(storageKey, JSON.stringify(bundle)); } catch (e) {}
    }
    if (droppedOnLoad > 0) persist();

    // Helpers
    function fmt(n) {
      return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c];
      });
    }
    function placeholderImg(title) {
      var initials = String(title).split(' ').slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase();
      return '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" aria-hidden="true">'
        + '<rect width="200" height="200" fill="#dcdcdc"/>'
        + '<g transform="translate(100,100)"><circle r="38" fill="rgba(255,255,255,.7)"/>'
        + '<text text-anchor="middle" dominant-baseline="central" font-family="ui-monospace, monospace" font-size="22" font-weight="700" fill="#0e0e0e">' + esc(initials) + '</text></g>'
        + '</svg>';
    }
    function catLabel(c) {
      return ({ cook:'Cook', eat:'Eat & Drink', sleep:'Sleep & Shelter', camp:'Camp', storage:'Storage', fuel:'Fuel' })[c] || (c || 'gear');
    }

    function entries() {
      return Object.keys(bundle).map(function (vid) {
        var entry = variantMap[vid];
        return entry ? { variantId: vid, product: entry.product, variant: entry.variant, qty: bundle[vid] } : null;
      }).filter(Boolean);
    }
    function totalItems()  { return entries().reduce(function (s, e) { return s + e.qty; }, 0); }
    function subtotal()    { return entries().reduce(function (s, e) { return s + e.variant.price * e.qty; }, 0); }
    function totalWeight() {
      return entries().reduce(function (s, e) {
        var g = Number(e.variant.weight_g || e.product.weight_g) || 0;
        return s + g * e.qty;
      }, 0);
    }
    function fmtWeight(g)  {
      if (!g) return '0 g';
      if (g < 1000) return Math.round(g) + ' g';
      return (g / 1000).toFixed(2) + ' kg';
    }
    // Weight is the brag for a moto-camping audience. Give the number a
    // real-world comparison so it lands.
    function weightContext(g) {
      if (!g) return '';
      if (g < 350)  return 'lighter than a can of drink';
      if (g < 750)  return 'about the weight of a 600ml water bottle';
      if (g < 1300) return 'about the weight of a 1L water bottle';
      if (g < 2400) return 'about the weight of a 2L bottle';
      if (g < 3600) return 'about the weight of a 3L hydration bladder';
      return 'and it all straps to the bike';
    }

    // Render: catalog grid
    function renderGrid() {
      var grid = $('[data-bb-grid]');
      if (!grid) return;
      grid.innerHTML = '';
      var list = products.slice();
      if (filter !== 'all') list = list.filter(function (p) { return p.category === filter; });
      if (sortBy === 'price-asc')  list.sort(function (a, b) { return productPrice(a) - productPrice(b); });
      if (sortBy === 'price-desc') list.sort(function (a, b) { return productPrice(b) - productPrice(a); });
      if (sortBy === 'weight-asc') list.sort(function (a, b) { return (productWeight(a) || 9e9) - (productWeight(b) || 9e9); });
      if (sortBy === 'essential')  list.sort(function (a, b) { return (b.essential ? 1 : 0) - (a.essential ? 1 : 0); });
      // Out of stock items always sort last within the active filter, whatever
      // the sort. They stay visible (email capture), never first.
      var inStock = list.filter(productAvailable);
      var oos = list.filter(function (p) { return !productAvailable(p); });
      list = inStock.concat(oos);

      if (!list.length) {
        grid.innerHTML = '<div class="bb-empty">No products match this filter.</div>';
        return;
      }

      var frag = document.createDocumentFragment();
      list.forEach(function (p) {
        var vs = variantsOf(p);
        var hasMulti = vs.length > 1;
        var prodAvail = productAvailable(p);
        var defaultVar = firstAvailableVariant(p);
        // Honour a variant choice the customer already made on this card.
        var savedVid = selectedVariant[p.id];
        if (savedVid) {
          var savedEntry = variantMap[savedVid];
          if (savedEntry && savedEntry.product === p) defaultVar = savedEntry.variant;
        }
        var defaultAvail = defaultVar.available !== false;
        var currentVarId = String(defaultVar.id);
        var qty = bundle[currentVarId] || 0;
        var inB = qty > 0;

        var card = document.createElement('article');
        var classes = ['bb-card'];
        if (inB) classes.push('is-in-bundle');
        if (!prodAvail) classes.push('is-oos');
        card.className = classes.join(' ');
        card.setAttribute('data-product-id', p.id);
        card.setAttribute('data-variant-id', currentVarId);
        card.setAttribute('role', 'listitem');
        var img = p.image
          ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">'
          : placeholderImg(p.title);
        var wg = productWeight(p);
        var weight = wg ? '<span class="bb-card-weight">' + wg + ' g</span>' : '';
        var tags = '';
        if (p.essential && prodAvail) tags += '<span class="bb-card-tag is-essential">Essential</span>';
        if (!prodAvail) tags += '<span class="bb-card-tag is-oos">Sold Out</span>';

        var variantSelect = '';
        if (hasMulti) {
          variantSelect = '<select class="bb-variant-select" data-variant-select aria-label="Choose ' + esc(p.option_name || 'option') + '">' +
            vs.map(function (v) {
              var vAvail = v.available !== false;
              var label = v.title + (vAvail ? '' : ' (Sold out)');
              return '<option value="' + esc(v.id) + '" data-price="' + v.price + '" data-available="' + (vAvail ? '1' : '0') + '"' +
                (vAvail ? '' : ' disabled') +
                (String(v.id) === currentVarId ? ' selected' : '') + '>' + esc(label) + '</option>';
            }).join('') +
          '</select>';
        }

        // Sold out products swap the Add button for a Notify Me link into the
        // product page's back-in-stock form. Email capture, not a dead end.
        var action;
        if (!prodAvail) {
          action = '<a class="bb-add bb-notify" href="' + esc(p.url || '/products/' + (p.handle || p.id)) + '" aria-label="Get notified when ' + esc(p.title) + ' is back in stock">Notify Me</a>';
        } else {
          var addDisabled = defaultAvail ? '' : ' disabled';
          action = '<button class="bb-add" type="button" data-action="add"' + addDisabled + ' aria-label="Add ' + esc(p.title) + ' to bundle">+ Add</button>';
        }

        card.innerHTML =
          '<div class="bb-card-img">' + img + tags + weight + '</div>' +
          '<div class="bb-card-body">' +
            '<div class="bb-card-cat">' + esc(catLabel(p.category)) + '</div>' +
            '<h3 class="bb-card-title">' + esc(p.title) + '</h3>' +
            '<p class="bb-card-blurb">' + esc(p.blurb || '') + '</p>' +
            variantSelect +
            '<div class="bb-card-foot">' +
              '<div class="bb-card-price"><span data-bb-card-price>' + fmt(defaultVar.price) + '</span><small>' + esc(CFG.currency) + '</small></div>' +
              action +
              (prodAvail ?
                '<div class="bb-card-qty" role="group" aria-label="Quantity for ' + esc(p.title) + '">' +
                  '<button type="button" data-action="dec" aria-label="Decrease">&minus;</button>' +
                  '<span class="bb-qty-val" data-qty>' + qty + '</span>' +
                  '<button type="button" data-action="inc" aria-label="Increase">+</button>' +
                '</div>' : '') +
            '</div>' +
          '</div>';
        frag.appendChild(card);
      });
      grid.appendChild(frag);
    }

    // Animated number for the bundle total. Watching it fall is the reward.
    var totalAnimFrame = null;
    function setTotal(el, from, to) {
      if (!el) return;
      // Always cancel a running animation first, even on the snap path,
      // or a stale frame can overwrite the freshly set total.
      if (totalAnimFrame) { cancelAnimationFrame(totalAnimFrame); totalAnimFrame = null; }
      if (REDUCED_MOTION || from == null || Math.abs(from - to) < 0.005) {
        el.textContent = fmt(to);
        return;
      }
      var start = null;
      var DUR = 400;
      function tick(ts) {
        if (start == null) start = ts;
        var t = Math.min(1, (ts - start) / DUR);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = fmt(from + (to - from) * eased);
        if (t < 1) totalAnimFrame = requestAnimationFrame(tick);
        else totalAnimFrame = null;
      }
      totalAnimFrame = requestAnimationFrame(tick);
    }
    var lastTotal = null;
    var lastQDisc = false;

    // Render: bundle rail
    function renderRail() {
      var es = entries();
      var sub = subtotal();
      var count = totalItems();

      var countEl = $('[data-bb-count]'); if (countEl) countEl.textContent = count;
      var peekCountEl = $('[data-bb-peek-count]'); if (peekCountEl) peekCountEl.textContent = count;

      var itemsEl = $('[data-bb-items]');
      var emptyEl = $('[data-bb-empty]');
      if (itemsEl && emptyEl) {
        Array.prototype.slice.call(itemsEl.children).forEach(function (n) {
          if (n !== emptyEl) itemsEl.removeChild(n);
        });
        if (!es.length) {
          emptyEl.style.display = '';
        } else {
          emptyEl.style.display = 'none';
          var frag = document.createDocumentFragment();
          es.forEach(function (e) {
            var p = e.product;
            var v = e.variant;
            var item = document.createElement('div');
            item.className = 'bb-item';
            item.setAttribute('role', 'listitem');
            item.setAttribute('data-variant-id', e.variantId);
            var img = p.image
              ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" decoding="async">'
              : placeholderImg(p.title);
            var titleHtml = esc(p.title) + (v && v.title ? ' <span class="bb-item-variant">&middot; ' + esc(v.title) + '</span>' : '');
            item.innerHTML =
              '<div class="bb-item-img">' + img + '</div>' +
              '<div class="bb-item-info">' +
                '<div class="bb-item-title">' + titleHtml + '</div>' +
                '<div class="bb-item-meta"><span>' + fmt(v.price) + '</span>' + (productWeight(p) ? '<span>&middot;</span><span>' + productWeight(p) + ' g</span>' : '') + '</div>' +
              '</div>' +
              '<div class="bb-item-right">' +
                '<div class="bb-item-qty" role="group">' +
                  '<button type="button" data-action="dec" aria-label="Decrease">&minus;</button>' +
                  '<span class="bb-qty-val" data-qty>' + e.qty + '</span>' +
                  '<button type="button" data-action="inc" aria-label="Increase">+</button>' +
                '</div>' +
                '<button class="bb-item-remove" type="button" data-action="remove" aria-label="Remove ' + esc(p.title) + '">Remove</button>' +
              '</div>';
            frag.appendChild(item);
          });
          itemsEl.appendChild(frag);
        }
      }

      var qDisc = count >= CFG.discountMinItems;
      var disc = qDisc ? sub * CFG.discountPct : 0;
      var afterDisc = sub - disc;
      // R1: free shipping is evaluated on the PRE-discount subtotal. Perks
      // stack, they do not cannibalise. Must match the Shopify shipping rule.
      var qShip = sub >= CFG.freeShipMin;
      var total = afterDisc;

      var elSub = $('[data-bb-subtotal]');     if (elSub) elSub.textContent = fmt(sub);
      var elDisc = $('[data-bb-discount]');    if (elDisc) elDisc.textContent = '-' + fmt(disc);
      var elTot = $('[data-bb-total]');
      // Animate the total on the unlock moment; snap it otherwise. Both paths
      // go through setTotal so a running animation is always cancelled.
      if (elTot) {
        if (qDisc !== lastQDisc && lastTotal != null && count > 0) setTotal(elTot, lastTotal, total);
        else setTotal(elTot, null, total);
      }
      lastTotal = total;
      lastQDisc = qDisc;
      var elPeekTotal = $('[data-bb-peek-total]'); if (elPeekTotal) elPeekTotal.textContent = fmt(total) + ' ' + CFG.currency;

      var rowDisc = $('[data-bb-row-discount]');
      var discLbl = $('[data-bb-discount-label]');
      var pctDisplay = Math.round(CFG.discountPct * 100);
      if (rowDisc && discLbl) {
        if (qDisc) {
          rowDisc.classList.remove('is-pending');
          discLbl.textContent = 'Bundle ' + pctDisplay + '% (auto)';
        } else {
          rowDisc.classList.add('is-pending');
          var need = Math.max(0, CFG.discountMinItems - count);
          discLbl.textContent = need === 0
            ? 'Bundle ' + pctDisplay + '%'
            : 'Add ' + need + ' more ' + (need === 1 ? 'item' : 'items') + ' for ' + pctDisplay + '% off';
        }
      }

      var strike = $('[data-bb-strike]');
      if (strike) {
        if (qDisc && count > 0) { strike.textContent = fmt(sub); strike.hidden = false; }
        else { strike.hidden = true; }
      }

      var savEl = $('[data-bb-savings]');
      if (savEl) savEl.textContent = disc > 0 ? 'You save ' + fmt(disc) : '';

      // Progress: items milestone and shipping milestone, always visible.
      var itemsPct = Math.min(1, count / CFG.discountMinItems) * 100;
      var shipPct = Math.min(1, sub / CFG.freeShipMin) * 100;
      var fillItems = $('[data-bb-fill-items]'); if (fillItems) fillItems.style.width = itemsPct + '%';
      var fillShip = $('[data-bb-fill-ship]');   if (fillShip) fillShip.style.width = shipPct + '%';
      var progVal = $('[data-bb-progress-val]');
      if (progVal) {
        if (count === 0) progVal.textContent = '';
        else if (qDisc && qShip) progVal.textContent = 'All perks unlocked';
        else if (!qDisc) progVal.textContent = (CFG.discountMinItems - count) + ' more ' + (CFG.discountMinItems - count === 1 ? 'item' : 'items') + ' to ' + pctDisplay + '% off';
        else progVal.textContent = fmt(CFG.freeShipMin - sub) + ' to free shipping';
      }

      // Mobile peek bar carries the same progress.
      var peekFill = $('[data-bb-peek-fill]');
      if (peekFill) peekFill.style.width = (!qDisc ? itemsPct : shipPct) + '%';
      var peekHint = $('[data-bb-peek-hint]');
      if (peekHint) {
        if (count === 0) peekHint.textContent = '';
        else if (!qDisc) peekHint.textContent = 'Add ' + (CFG.discountMinItems - count) + ' more ' + (CFG.discountMinItems - count === 1 ? 'item' : 'items') + ' for ' + pctDisplay + '% off';
        else if (!qShip) peekHint.textContent = 'Spend ' + fmt(CFG.freeShipMin - sub) + ' more for free shipping';
        else peekHint.textContent = 'All perks unlocked';
      }

      var tDisc = $('[data-bb-tier-discount]'); if (tDisc) tDisc.classList.toggle('is-hit', qDisc);
      var tShip = $('[data-bb-tier-shipping]'); if (tShip) tShip.classList.toggle('is-hit', qShip && count > 0);

      var s1 = $('[data-step="1"]'), s2 = $('[data-step="2"]'), s3 = $('[data-step="3"]');
      if (s1 && s2 && s3) {
        [s1, s2, s3].forEach(function (s) { s.classList.remove('is-active'); s.classList.remove('is-done'); });
        if (count === 0) s1.classList.add('is-active');
        else if (!qDisc && !qShip) { s1.classList.add('is-done'); s2.classList.add('is-active'); }
        else { s1.classList.add('is-done'); s2.classList.add('is-done'); s3.classList.add('is-active'); }
      }

      var cta = $('[data-bb-cta]');
      var ctaLbl = $('[data-bb-cta-label]');
      if (cta && ctaLbl && !cta.dataset.bbBusy) {
        if (count === 0) { cta.disabled = true; ctaLbl.textContent = 'Add at least 1 item'; }
        else { cta.disabled = false; ctaLbl.textContent = 'Add to Cart · ' + count + ' ' + (count === 1 ? 'item' : 'items') + ' · ' + fmt(total); }
      }

      // Near-miss prompt: one item short of the discount, with the real dollar
      // figure. Highest-leverage line in the builder.
      var nearEl = $('[data-bb-nearmiss]');
      if (nearEl) {
        if (count === CFG.discountMinItems - 1 && count > 0) {
          nearEl.hidden = false;
          nearEl.textContent = 'Add 1 more item to unlock ' + pctDisplay + '% off. That saves you ' + fmt(sub * CFG.discountPct) + ' on this bundle.';
        } else {
          nearEl.hidden = true;
          nearEl.textContent = '';
        }
      }

      var weightEl = $('[data-bb-weight]');
      var tw = totalWeight();
      if (weightEl) {
        weightEl.textContent = fmtWeight(tw);
        weightEl.classList.toggle('is-empty', tw === 0);
      }
      var weightCtx = $('[data-bb-weight-context]');
      if (weightCtx) weightCtx.textContent = tw > 0 ? weightContext(tw) : '';

      $$('.bb-card').forEach(function (c) {
        var vid = c.getAttribute('data-variant-id');
        var q = bundle[vid] || 0;
        c.classList.toggle('is-in-bundle', q > 0);
        var qe = c.querySelector('.bb-card-qty [data-qty]');
        if (qe) qe.textContent = q;
      });
    }

    // Mutations, keyed by variant id (string)
    function add(vid, n) {
      n = n || 1;
      vid = String(vid);
      var prevCount = totalItems();
      var prevSub = subtotal();
      bundle[vid] = (bundle[vid] || 0) + n;
      if (bundle[vid] <= 0) delete bundle[vid];
      persist();
      var newCount = totalItems();
      var newSub = subtotal();
      var qDP = prevCount >= CFG.discountMinItems;
      var qDN = newCount  >= CFG.discountMinItems;
      if (!qDP && qDN) celebrate(Math.round(CFG.discountPct * 100) + '% bundle discount unlocked');
      // R1: free shipping milestone tracks the pre-discount subtotal.
      if (prevSub < CFG.freeShipMin && newSub >= CFG.freeShipMin) celebrate('FREE shipping unlocked');
      renderRail();
    }
    function remove(vid) { delete bundle[String(vid)]; persist(); renderRail(); }
    function setQty(vid, q) {
      vid = String(vid);
      if (q <= 0) delete bundle[vid]; else bundle[vid] = q;
      persist();
      renderRail();
    }

    // Toast + celebrate
    var toastTimer;
    function toast(msg) {
      var el = $('[data-bb-toast]');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2600);
    }
    function celebrate(msg) {
      toast(msg);
      var rail = $('[data-bb-rail]');
      if (!rail) return;
      rail.classList.remove('is-celebrate');
      void rail.offsetWidth;
      rail.classList.add('is-celebrate');
    }
    if (droppedOnLoad > 0) {
      toast(droppedOnLoad === 1
        ? 'One item sold out and was removed from your bundle.'
        : 'Some items sold out and were removed from your bundle.');
    }

    // Add-to-bundle feedback: the product image flies to the rail (desktop)
    // or the peek bar (mobile). Pure transform, never blocks anything.
    function flyToRail(card) {
      if (REDUCED_MOTION || !card) return;
      var imgBox = card.querySelector('.bb-card-img img');
      if (!imgBox) return;
      var rail = $('[data-bb-rail]');
      if (!rail) return;
      var target = null;
      var peek = $('[data-bb-peek]');
      if (peek && peek.offsetParent !== null) target = peek;
      else {
        var head = rail.querySelector('.bb-rail-head');
        if (head && head.offsetParent !== null) target = head;
      }
      if (!target) return;
      var from = imgBox.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      var ghost = imgBox.cloneNode(false);
      ghost.className = 'bb-fly';
      ghost.style.top = from.top + 'px';
      ghost.style.left = from.left + 'px';
      ghost.style.width = from.width + 'px';
      ghost.style.height = from.height + 'px';
      document.body.appendChild(ghost);
      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
      requestAnimationFrame(function () {
        ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12)';
        ghost.style.opacity = '0.2';
      });
      var cleaned = false;
      function cleanup() {
        if (cleaned) return;
        cleaned = true;
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        var badge = $('[data-bb-count]');
        if (badge) {
          badge.classList.remove('is-pulse');
          void badge.offsetWidth;
          badge.classList.add('is-pulse');
        }
      }
      ghost.addEventListener('transitionend', cleanup);
      setTimeout(cleanup, 450);
    }

    // Events
    var grid = $('[data-bb-grid]');
    if (grid) {
      // Variant select change: update the card's active variant id, displayed
      // price, Add state, in-bundle state and quantity readout.
      grid.addEventListener('change', function (ev) {
        var sel = ev.target.closest('[data-variant-select]');
        if (!sel) return;
        var card = ev.target.closest('.bb-card');
        if (!card) return;
        var vid = sel.value;
        card.setAttribute('data-variant-id', vid);
        selectedVariant[card.getAttribute('data-product-id')] = vid;
        var opt = sel.options[sel.selectedIndex];
        var price = opt ? Number(opt.getAttribute('data-price')) : null;
        var avail = opt ? opt.getAttribute('data-available') !== '0' : true;
        if (price != null && !isNaN(price)) {
          var pe = card.querySelector('[data-bb-card-price]');
          if (pe) pe.textContent = fmt(price);
        }
        var addBtn = card.querySelector('button.bb-add');
        if (addBtn) {
          addBtn.disabled = !avail;
          addBtn.textContent = avail ? '+ Add' : 'Sold Out';
        }
        // Resync bundle state to the newly selected variant.
        var q = bundle[String(vid)] || 0;
        card.classList.toggle('is-in-bundle', q > 0);
        var qe = card.querySelector('.bb-card-qty [data-qty]');
        if (qe) qe.textContent = q;
      });

      grid.addEventListener('click', function (ev) {
        var btn = ev.target.closest('button[data-action]');
        if (!btn || btn.disabled) return;
        var card = ev.target.closest('.bb-card');
        if (!card) return;
        var vid = card.getAttribute('data-variant-id');
        var entry = variantMap[vid];
        if (!entry) return;
        if (!entry.available) return; // defensive: never add OOS variants
        var p = entry.product;
        var v = entry.variant;
        var label = v.title ? (p.title + ', ' + v.title) : p.title;
        var act = btn.getAttribute('data-action');
        if (act === 'add')      { add(vid, 1); flyToRail(card); toast(label + ' added'); }
        else if (act === 'inc') { add(vid, 1); }
        else if (act === 'dec') { var c = bundle[vid] || 0; if (c <= 1) remove(vid); else setQty(vid, c - 1); }
      });
    }

    var itemsEl2 = $('[data-bb-items]');
    if (itemsEl2) {
      itemsEl2.addEventListener('click', function (ev) {
        var btn = ev.target.closest('button[data-action]');
        if (!btn) return;
        var item = ev.target.closest('.bb-item');
        if (!item) return;
        var vid = item.getAttribute('data-variant-id');
        var act = btn.getAttribute('data-action');
        if (act === 'remove')   { remove(vid); }
        else if (act === 'inc') { add(vid, 1); }
        else if (act === 'dec') { var c = bundle[vid] || 0; if (c <= 1) remove(vid); else setQty(vid, c - 1); }
      });
    }

    // Starter kits: resolve handles against the builder catalogue only, so
    // nothing outside the collection can enter through a kit. Sold out
    // products are skipped, never silently added.
    $$('[data-bb-kit]').forEach(function (kitBtn) {
      kitBtn.addEventListener('click', function () {
        var handles = (kitBtn.getAttribute('data-bb-kit') || '').split(',');
        var added = 0, skipped = 0;
        var prevCount = totalItems();
        var prevSub = subtotal();
        handles.forEach(function (h) {
          h = h.trim();
          if (!h) return;
          var p = productByHandle[h];
          if (!p || !productAvailable(p)) { skipped++; return; }
          var v = firstAvailableVariant(p);
          var vid = String(v.id);
          if (!bundle[vid]) { add(vid, 1); added++; }
        });
        renderGrid();
        renderRail();
        // If the kit just crossed a milestone, celebrate() already fired a
        // toast; don't overwrite the reward moment with a generic count.
        var crossedMilestone =
          (prevCount < CFG.discountMinItems && totalItems() >= CFG.discountMinItems) ||
          (prevSub < CFG.freeShipMin && subtotal() >= CFG.freeShipMin);
        if (added === 0 && skipped === 0) toast('Those items are already in your bundle');
        else if (crossedMilestone) return;
        else if (added > 0 && skipped === 0) toast(added + ' item' + (added === 1 ? '' : 's') + ' added to your bundle');
        else if (added > 0) toast(added + ' added, ' + skipped + ' unavailable and skipped');
        else if (skipped > 0) toast('Those items are unavailable right now');
      });
    });

    $$('.bb-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        $$('.bb-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        filter = chip.getAttribute('data-filter');
        renderGrid();
        renderRail();
      });
    });

    var sortEl = $('[data-bb-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', function (ev) {
        sortBy = ev.target.value;
        renderGrid();
        renderRail();
      });
    }

    function setRailOpen(open) {
      var rail = $('[data-bb-rail]');
      if (!rail) return;
      rail.classList.toggle('is-open', open);
      var peek = $('[data-bb-peek]');
      if (peek) peek.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    var peekBtn = $('[data-bb-peek]');
    if (peekBtn) {
      peekBtn.addEventListener('click', function () {
        var rail = $('[data-bb-rail]');
        if (!rail) return;
        setRailOpen(!rail.classList.contains('is-open'));
      });
    }

    var dragY = null;
    var railEl = $('[data-bb-rail]');
    if (railEl) {
      railEl.addEventListener('touchstart', function (ev) {
        if (!railEl.classList.contains('is-open')) return;
        var t = ev.touches[0];
        if (t && ev.target.closest('.bb-rail-handle, .bb-rail-head')) dragY = t.clientY;
      }, { passive: true });
      railEl.addEventListener('touchmove', function (ev) {
        if (dragY == null) return;
        var t = ev.touches[0];
        if (t && t.clientY - dragY > 40) { setRailOpen(false); dragY = null; }
      }, { passive: true });
      railEl.addEventListener('touchend', function () { dragY = null; });
    }

    // Revalidate stock against live product data before submitting. The page
    // is rendered at load (and may be cached), so anything that sold out
    // mid-session gets caught here instead of 422ing at the cart.
    function revalidateBundle() {
      var handles = {};
      entries().forEach(function (e) { handles[e.product.handle || e.product.id] = true; });
      var list = Object.keys(handles);
      return Promise.all(list.map(function (h) {
        return fetch('/products/' + h + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (results) {
        var liveAvail = {};
        results.forEach(function (pj) {
          if (!pj || !pj.variants) return;
          pj.variants.forEach(function (v) { liveAvail[String(v.id)] = v.available; });
        });
        var dropped = 0;
        Object.keys(bundle).forEach(function (vid) {
          if (liveAvail[vid] === false) { delete bundle[vid]; dropped++; }
        });
        if (dropped > 0) {
          persist();
          renderGrid();
          renderRail();
        }
        return dropped;
      });
    }

    var ctaBtn = $('[data-bb-cta]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var es = entries();
        if (!es.length || ctaBtn.dataset.bbBusy) return;
        var ctaLbl = $('[data-bb-cta-label]');
        ctaBtn.dataset.bbBusy = '1';
        ctaBtn.disabled = true;
        if (ctaLbl) ctaLbl.textContent = 'Adding to cart';

        function releaseCta() {
          delete ctaBtn.dataset.bbBusy;
          ctaBtn.disabled = false;
          renderRail();
        }

        revalidateBundle().then(function (dropped) {
          if (dropped > 0) {
            toast(dropped === 1
              ? 'One item sold out and was removed from your bundle.'
              : 'Some items sold out and were removed from your bundle.');
            releaseCta();
            return;
          }
          var items = entries().map(function (e) { return { id: Number(e.variantId) || e.variant.id, quantity: e.qty }; });
          if (!items.length) { releaseCta(); return; }
          var qDisc = totalItems() >= CFG.discountMinItems;
          var attrs = {
            bundle: CFG.bundleSlug,
            bundle_items: String(totalItems()),
            bundle_discount: qDisc ? CFG.bundleToken : ''
          };
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (r) {
            if (!r.ok) {
              // Shopify returns 422 for the whole request if any line fails.
              return r.json().catch(function () { return {}; }).then(function (body) {
                var msg = (body && (body.description || body.message)) || 'Could not add your bundle to the cart.';
                throw new Error(msg);
              });
            }
            return r.json();
          })
          .then(function () {
            // Attribution attributes: builder-originated orders stay
            // distinguishable from ordinary qualifying carts. Best-effort;
            // never blocks checkout.
            return fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attrs })
            }).then(function (r) {
              if (r && !r.ok) console.warn('SOLARA bundle: attribute update returned', r.status);
            }).catch(function (err) {
              console.warn('SOLARA bundle: attribute update failed', err);
            });
          })
          .then(function () { window.location.href = '/cart'; })
          .catch(function (err) {
            console.error('SOLARA bundle: cart add failed', err);
            toast(err && err.message ? err.message : 'Could not add bundle. Please try again.');
            releaseCta();
          });
        }).catch(function (err) {
          // Terminal guard: nothing may leave the CTA stuck in its busy state.
          console.error('SOLARA bundle: revalidation failed', err);
          toast('Could not add bundle. Please try again.');
          releaseCta();
        });
      });

      // bfcache: navigating back from /cart restores the page mid-busy state.
      // Release the CTA so it is never permanently stuck disabled.
      window.addEventListener('pageshow', function (ev) {
        if (ev.persisted) {
          delete ctaBtn.dataset.bbBusy;
          ctaBtn.disabled = false;
          renderRail();
        }
      });
    }

    renderGrid();
    renderRail();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.solara-bb')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor swaps section markup
  document.addEventListener('shopify:section:load', initAll);
})();
